<!-- 系统角色管理 -->
<template>
  <div class="fuzzy-matching-box">
    <div class="titleRole" v-if="titleValue == '系统角色'">
      <div class="fuzzy-matching-top">
        <!-- <h1 class="titleStyle">角色系统管理</h1> -->
        <el-button type="primary" size="medium" class="query-button" @click="addRoleClick">新增系统角色</el-button>
    </div>
    <div class="fuzzy-matching-bottom">
      <el-row class="list">
         <el-table
         class="table-Style"
         :header-cell-style="{background:'#EDF6FF',color:'#000',}"
         stripe
          :border="true"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column
            prop="name"
            label="名称"
            >
          </el-table-column>
          <el-table-column
          label='操作'>
          <template #default="scope">
            <el-button size="medium" type="text" @click="deleteClick(scope.row)" class="shanchuBtn">删除</el-button>
              <el-button size="medium" type="text" @click="XiugaiClick(scope.row)" class="StyleBtn">修改</el-button>
              <el-button size="medium" type="text" @click="UserClick(scope.row)" class="StyleBtn">授权用户管理</el-button>
           </template>
          </el-table-column>
        </el-table>
        <div class="block-fenye" >
          <el-pagination
              :small="small"
              :disabled="disabled"
              :background="background"
              layout="prev, pager, next, jumper"
              :total="total"
              :page-size="pageInfo.pageSize"
              :current-page="Number(pageInfo.page)"
              @size-change="handlerSizeChange"
              @current-change="handleCurrentChange"
            />
        </div>
      </el-row>

    </div>
    </div>
    <RoleAdd v-if="titleValue == '新增系统角色' || titleValue == '修改系统角色'" @fanhui="fanhui" :xiugaiItem="xiugaiItem" :titleValue="titleValue"></RoleAdd>
    <UserAdd v-if="titleValue == '授权用户'" :userObj="userObj" @fatchback="fatchback"></UserAdd>
  </div>
</template>

<script>
import RoleAdd from './roleAdd/index.vue'
import UserAdd from './userAdd/index.vue'
import { menuRolePagedList,menuremoveRoleDelete,} from '@/assets/api/user.js'
export default {
  components: {
    RoleAdd,
    UserAdd
  },
  data() {
      return {
        Dform:{
          name:''
        },
        titleValue:'系统角色',
        tableData: [],
        pageInfo:{
          page:1,
          pageSize:10
        },
        total:0,
        userObj:{},
        xiugaiItem: {},
        loading:false
      };
  },
  created() {
    this.getUserList()
  },
  mounted() {

  },
  methods: {
    //分页条数变更
    handlerSizeChange(val){
      this.pageInfo.pageSize = val;
      this.pageInfo.page = 1;
      this.getUserList();
    },
    //分页当前页变更
    handleCurrentChange(val){
      this.pageInfo.page = val;
      this.getUserList();
    },
    // 多选框选择事件（原代码未实现，保留空方法避免报错）
    handleSelectionChange() {},
    fanhui () {
      this.titleValue='系统角色'
      this.getUserList()
    },
    XiugaiClick (item) {
      this.titleValue = '修改系统角色'
      this.xiugaiItem = item
      console.log(this.xiugaiItem,'修改');
    },
    // 授权用户
    UserClick(item){
      this.userObj = item
      this.titleValue ='授权用户'
    },
    //父传子返回
    fatchback(){
      this.titleValue = '系统角色'
      this.getUserList();//刷新列表
    },
    // 新增
    addRoleClick(){
      this.titleValue = '新增系统角色'
    },
    //删除
    deleteClick(item){
      this.$confirm('确定删除该系统角色？删除后不可恢复','温馨提示',{
        type:"warning",
        confirmButtonText:'确定',
        cancelButtonText:'取消'
      }).then(()=>{
        const params = {
          roleId:item.id
        }
        menuremoveRoleDelete(params).then((res)=> {
          console.log(res,'成功');
          this.$message({
            type: 'success',
            message: '删除成功'
          });
          this.getUserList()
        }).catch((err)=> {
          // console.log(err,'失败');
          this.$message({
            type: 'error',
            message: err.response?.data?.msg || '删除失败'
          });

        })
      }).catch(()=>{
        this.$message({
          type:'info',
          message:'已取消删除'
        });
      });


    },
    // 列表
    getUserList(){
      menuRolePagedList(this.pageInfo.page,this.pageInfo.pageSize).then((res)=> {
        console.log(res.data.data.records,'1');
        this.tableData = res.data.data.records
        this.total =  res.data.data.total
      }).catch((err) => {
        console.log(err,'2');

      })
    }
  },
};
</script>

<style scoped lang="scss">
  .fuzzy-matching-box {
    width: 100%;
    height:  95%;
    .titleRole{
      height: 100%;
      .fuzzy-matching-top{
        height: 100px;
        background-color: #FFF;
        border-radius: 15px;
        display: flex;
        align-content: space-around;  
        align-items: center;
        .titleStyle{
          margin-left: 40px;
          font-size: 20px;
          font-weight: 700;
          width: 85%;
        }
      }

    }

    .query-button{
      margin-left: 20px;
      margin-top: 10px;
      border-radius: 15px;
      // background-color: #1BC896;
      }
   
  }
  .fuzzy-matching-bottom {
    height:85%;
    overflow: auto;
    position: relative;
    padding: 0px 20px;
    padding-top: 30px;
    margin-top: 15px;
    background-color: #fff;
    border-radius: 15px;
    .table-Style{
      font-size: 16px;
      // border-radius: 15px;
    }
    .shanchuBtn {
      font-size: 15px;
      font-weight: 700;
      color: red;
    }
    .StyleBtn{
      font-size: 15px;
      font-weight: 700;
      // color: #1BC896;
    }
    .top-first-line {
      height: 45px;
      line-height: 45px;
        :deep(.tip-button) {
          padding: 14px 14px;
          margin: 0px 3px;
        }
  
    }
    .list {
      position: relative;
      // margin-top: 10px;
      padding-bottom: 50px;
     .fenye {
      // float: right;
      text-align: center;
     }
      :deep() {
        .el-table--small .cell {
          text-align: center;
        }
        .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
          // border: 0px;
        }
        .el-table tr {
          height: 40px;
          cursor: pointer;
          user-select: none;
          font-size: 16px;
          color: black;
        }
        .el-table th.el-table__cell>.cell{
          font-weight: 700;
        }
      }
      .block-fenye {
        // float: right;
        position: absolute;
        bottom: 0px;
        left: 50%;
        transform: translate(-50%,0);
        
      }
    }
  }

</style>
